module.exports = __webpack_public_path__ + "img/competitor.aa48a571.jpg";